<template src="@/components/AddressModal.html"/>
<style lang="scss" scoped src="@/components/AddressModal.scss"/>

<script>

import {
  SfBar,
  SfButton,
  SfModal,
  SfHeading
} from '@storefront-ui/vue';

import AddressForm from "@/components/MyAccount/AddressForm";
import {CustomerActions} from "@/config/store/customer/actions";


export default {
  name: 'AddressModal',
  components: {
    AddressForm,
    SfHeading,
    SfBar,
    SfButton,
    SfModal
  },
  computed: {
    isAddressModalOpen: function() { return this.$store.getters.isAddressModalOpen; },
    customer: function() { return this.$store.getters.getProfile; },
  },

  methods: {
    submitAddress({address, onComplete, onError}) {
      address.defaultShipping = this.isAddressModalOpen.isShipping
      address.defaultBilling = this.isAddressModalOpen.isBilling

      this.$store.dispatch(CustomerActions.addCustomerAddress, {isNew: !this.isAddressModalOpen.address, address})
          .then((data) => {
            onComplete(data)
            this.toggleAddressModal()
          })
          .catch((e) => onError(e))
    },

    toggleAddressModal() {
      this.$store.dispatch('toggleAddressModal',{open:false,address:null})
    },

  }
};
</script>